import { CheckCircle2 } from "lucide-react";
import Reveal from "./Reveal";

const points = [
  "Skonsamma metoder utan högt tryck",
  "Tydlig återkoppling före och efter",
  "Vi städar efter oss när arbetet är klart",
  "Rådgivning kring rätt åtgärd",
];

export default function About() {
  return (
    <section
      id="om-oss"
      data-testid="section-about"
      className="bg-[#F7F5F0] py-24 md:py-32"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10 lg:px-14">
        <div className="grid lg:grid-cols-12 gap-12 lg:gap-20 items-center">
          {/* Image */}
          <Reveal className="lg:col-span-6 order-2 lg:order-1">
            <div className="relative">
              <div className="relative rounded-[20px] overflow-hidden aspect-[4/5] shadow-[0_24px_60px_rgba(26,54,43,0.18)]">
                <img
                  data-testid="about-image"
                  src="https://images.unsplash.com/photo-1576941089067-2de3c901e126?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODF8MHwxfHNlYXJjaHwxfHxzd2VkaXNoJTIwaG91c2UlMjBleHRlcmlvcnxlbnwwfHx8fDE3Nzk0NDg0NjZ8MA&ixlib=rb-4.1.0&q=85"
                  alt="Klassiskt svenskt hus med välunderhållet tak och fasad"
                  className="w-full h-full object-cover"
                  loading="lazy"
                />
              </div>
              {/* Floating accent card */}
              <div className="hidden md:block absolute -bottom-8 -right-6 w-56 bg-[#1A362B] text-[#F7F5F0] rounded-2xl p-6 shadow-[0_24px_60px_rgba(0,0,0,0.18)]">
                <div className="text-[11px] uppercase tracking-[0.18em] text-[#F7F5F0]/60">
                  Vårt arbetssätt
                </div>
                <div className="mt-3 font-serif-display text-2xl leading-tight">
                  Hellre varsamt än hårt.
                </div>
              </div>
            </div>
          </Reveal>

          {/* Text */}
          <Reveal className="lg:col-span-6 order-1 lg:order-2">
            <div className="text-[11px] tracking-[0.22em] uppercase text-[#1A362B]/70">
              Om Svea Ytservice
            </div>
            <h2 className="mt-4 font-serif-display text-3xl sm:text-4xl lg:text-5xl tracking-tight text-[#1F2321] text-balance">
              Vi värnar om{" "}
              <span className="text-[#1A362B]">tak och fasad</span> — utan att slita på dem.
            </h2>
            <p
              data-testid="about-text"
              className="mt-6 text-[#5C6B64] leading-relaxed text-[16px] md:text-[17px]"
            >
              Svea Ytservice AB hjälper kunder att ta hand om tak, fasad och utsatta
              ytor med fokus på noggrannhet, tydlig kommunikation och skonsamma
              arbetsmetoder. Vi tror att rätt åtgärd vid rätt tillfälle är det
              som gör att ytor håller över tid.
            </p>

            <ul className="mt-8 grid sm:grid-cols-2 gap-3">
              {points.map((p) => (
                <li key={p} className="flex items-start gap-3 text-[#1F2321]">
                  <CheckCircle2 size={18} className="text-[#1A362B] mt-0.5 shrink-0" strokeWidth={1.7} />
                  <span className="text-[15px] leading-relaxed">{p}</span>
                </li>
              ))}
            </ul>

            <a
              href="#kontakt"
              data-testid="btn-about-contact"
              className="mt-10 inline-flex items-center bg-[#1A362B] text-[#F7F5F0] hover:bg-[#244739] rounded-full px-6 py-3.5 font-medium transition-colors"
            >
              Berätta vad du behöver hjälp med
            </a>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
